import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthLayout from "./AuthLayout";
import { api, apiError, nextFrom } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, ErrorState } from "@/components/common";

export const GoogleButton = () => {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/command-centre";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" data-testid="google-signin-button" onClick={go} className="cq-btn cq-btn-ghost w-full !py-2.5">
      <svg width="16" height="16" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
      Continue with Google
    </button>
  );
};

export const Divider = () => (
  <div className="flex items-center gap-3 my-6"><div className="h-px flex-1 bg-[#243153]" /><span className="cq-muted-label">or</span><div className="h-px flex-1 bg-[#243153]" /></div>
);

export default function Login() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      nav(nextFrom(loc.search) || loc.state?.from || "/command-centre", { replace: true });
    } catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Sign in" subtitle="Welcome back to your command centre.">
      <GoogleButton />
      <Divider />
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email"><input data-testid="login-email-input" type="email" required autoComplete="email" className="cq-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Field>
        <Field label="Password"><input data-testid="login-password-input" type="password" required autoComplete="current-password" className="cq-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></Field>
        {err && <ErrorState message={err} testId="login-error" />}
        <button data-testid="login-submit-button" disabled={busy} className="cq-btn cq-btn-primary w-full !py-2.5">
          {busy && <Loader2 size={14} className="animate-spin" />} Sign in
        </button>
      </form>
      <div className="mt-6 flex justify-between text-sm">
        <Link data-testid="forgot-password-link" to="/forgot-password" className="text-[#AAB6CC] hover:text-[#22E6F2]">Forgot password?</Link>
        <Link data-testid="register-link" to={`/register${loc.search}`} className="text-[#22E6F2] hover:underline">Create account</Link>
      </div>
    </AuthLayout>
  );
}
